/* Alarie - movimiento general.
   De donde se lee el scroll: alarie-scroll.js (en este tema NO es la ventana). */
(function () {
  'use strict';
  if (window.__alarieMotion) return;
  window.__alarieMotion = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var S = window.AlarieScroll;

  function sc() {
    if (S) return S.container(document.querySelector('.al') || document.body);
    return document.scrollingElement || document.documentElement;
  }
  function pos(el) { return S ? S.top(el) : (window.scrollY || 0); }

  function onScroll(fn) {
    var pending = 0;
    function run() {
      if (pending) return;
      pending = 1;
      window.requestAnimationFrame(function () { pending = 0; fn(); });
      window.setTimeout(function () { if (pending) { pending = 0; fn(); } }, 120);
    }
    if (S) S.on(document.querySelector('.al') || document.body, run);
    else { window.addEventListener('scroll', run, { passive: true }); window.addEventListener('resize', run, { passive: true }); }
    fn();
  }

  function progressBar() {
    if (reduce || document.getElementById('alProgress')) return;
    var el = document.createElement('div');
    el.id = 'alProgress';
    document.body.appendChild(el);
    onScroll(function () {
      var c = sc();
      var h = c.scrollHeight - c.clientHeight;
      var p = h > 0 ? pos(c) / h : 0;
      el.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
    });
  }

  function grain() {
    if (reduce || document.getElementById('alGrain')) return;
    var g = document.createElement('div');
    g.id = 'alGrain';
    document.body.appendChild(g);
  }

  function markRise() {
    var groups = document.querySelectorAll('.al .al-sec, .al .al-trust, .al .al-pdp, .al .al-footer__top');
    Array.prototype.forEach.call(groups, function (g) {
      var kids = [];
      var grid = g.querySelector('.al-grid, .al-list, .al-faq, .al-specs, .al-incl');
      Array.prototype.forEach.call(g.children, function (c) { kids.push(c); });
      if (grid && grid.children.length > 1) {
        kids = kids.filter(function (k) { return k !== grid; });
        Array.prototype.forEach.call(grid.children, function (c) { kids.push(c); });
      }
      kids.forEach(function (el, i) {
        if (el.classList.contains('al-rise')) return;
        el.classList.add('al-rise');
        el.style.setProperty('--i', String(Math.min(i, 6)));
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('.al-card__media'), function (m) {
      m.classList.add('al-clip');
    });
    var h1 = document.querySelector('.al-hero h1');
    if (h1) h1.classList.add('al-watch');
    var num = document.querySelector('.al-num');
    if (num) { var g2 = num.closest('.al-grid'); if (g2) g2.classList.add('al-steps', 'al-watch-steps'); }
    var card = document.querySelector('.al-card');
    if (card) { var mg = card.closest('.al-grid'); if (mg) mg.classList.add('al-moments-grid'); }
  }

  function observeAll() {
    var items = document.querySelectorAll('.al-rise, .al-clip, .al-watch, .al-watch-steps');
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in', 'is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.classList.contains('al-watch-steps')) e.target.classList.add('is-drawn');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(items, function (el) {
      if (el.classList.contains('is-in')) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-in');
        if (el.classList.contains('al-watch-steps')) el.classList.add('is-drawn');
      } else { io.observe(el); }
    });
  }

  function header() {
    var h = document.querySelector('.al-headwrap');
    if (!h) return;
    var on = false;
    onScroll(function () {
      var should = pos(sc()) > 24;
      if (should !== on) { on = should; h.classList.toggle('is-scrolled', on); }
    });
  }

  function gallery() {
    var main = document.getElementById('alGalMain');
    if (!main) return;
    var thumbs = document.querySelectorAll('.al-gal__thumbs button[data-src]');
    Array.prototype.forEach.call(thumbs, function (b) {
      if (b.dataset.alBound) return;
      b.dataset.alBound = '1';
      b.addEventListener('click', function () {
        var img = main.querySelector('img');
        if (!img || img.src === b.dataset.src) return;
        Array.prototype.forEach.call(thumbs, function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        if (reduce) { img.src = b.dataset.src; return; }
        main.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          img.src = b.dataset.src;
          requestAnimationFrame(function () { main.classList.remove('is-swapping'); });
        };
        pre.src = b.dataset.src;
      });
    });
  }

  function packs() {
    var price = document.getElementById('alPrice');
    Array.prototype.forEach.call(document.querySelectorAll('.al-pack'), function (l) {
      if (l.dataset.alBound) return;
      l.dataset.alBound = '1';
      l.addEventListener('click', function () {
        if (!price || reduce) return;
        price.classList.add('is-bump');
        setTimeout(function () { price.classList.remove('is-bump'); }, 250);
      });
    });
  }

  function sticky() {
    var bar = document.querySelector('.al-sticky');
    var form = document.getElementById('alForm');
    if (!bar || !form) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-up'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-up', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(form);
  }

  function init() {
    S = window.AlarieScroll || S;
    /* grain() desactivado: la capa fija con ruido SVG y mezcla multiply hacia que el iPhone se quedara sin memoria */
    progressBar(); markRise(); observeAll();
    header(); gallery(); packs(); sticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    markRise(); observeAll(); gallery(); packs();
  });
})();

/* Alarie - toques premium (titulos que se destapan, fotos que se asientan,
   porcentajes que cuentan, botones con rebote y saltito). Todo se apaga si el movil pide
   menos movimiento. Las fotos y numeros que ya se ven al cargar no se tocan. */
(function () {
  'use strict';
  if (window.__alariePremium) return;
  window.__alariePremium = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = [
    /* 1. titulos: cada palabra sube desde detras de una mascara */
    '.alw{display:inline-block;overflow:hidden;vertical-align:top;padding-bottom:.16em;margin-bottom:-.16em}',
    '.alw>span{display:inline-block;transform:translateY(108%);transition:transform .95s cubic-bezier(.2,.75,.2,1);transition-delay:calc(var(--w,0) * 55ms)}',
    '.alw-on .alw>span{transform:none}',
    /* 2. fotos: entran con un poco de zoom y se asientan */
    '.al-settle{transform:scale(1.08);opacity:.001;transition:transform 1.5s cubic-bezier(.2,.7,.2,1),opacity .9s ease}',
    '.al-settle.is-set{transform:none;opacity:1}',
    /* 3. numeros: ancho fijo para que no baile el texto */
    '.al-count{font-variant-numeric:tabular-nums}',
    /* 6. botones: se levantan al pasar (ordenador) */
    '@media(hover:hover) and (pointer:fine){.al .al-pdAdd:hover,.al .al-btn:hover,.alpo__btn:hover,.cart__checkout-button.button:hover{transform:translateY(-3px) !important;box-shadow:0 8px 0 0 #111 !important}}',
    /* 7. pulsacion con rebote: al tocar se hunde rapido y al soltar vuelve con un pequeno rebote */
    '.al .al-pdAdd,.al .al-buy2,.al .al-btn,.alpo__btn,.cart__checkout-button.button,.cart-discount__button.button,.button-primary{transition:background-color .15s ease,transform .42s cubic-bezier(.34,1.8,.5,1),box-shadow .42s cubic-bezier(.34,1.8,.5,1) !important}',
    '.al .al-pdAdd:active,.al .al-buy2:active,.al .al-btn:active,.alpo__btn:active,.cart__checkout-button.button:active,.cart-discount__button.button:active,.button-primary:active{transition:background-color .15s ease,transform .07s ease,box-shadow .07s ease !important}',
    /* 8. saltito: los dos botones principales de compra (anadir a la cesta de la ficha y
       "Comprar" de la portada) suben un poco y vuelven cada 5 s, como una tecla. Se para al pasar o pulsar. */
    '.al .al-pdAdd{--al-e:5px}.alpo__btn{--al-e:4px}',
    '.al .al-pdAdd,.alpo__btn{animation:alHop 5s ease-in-out infinite}',
    '.al .al-pdAdd:hover,.al .al-pdAdd:active,.al .al-pdAdd:focus-visible,.al .al-pdAdd.is-added,.alpo__btn:hover,.alpo__btn:active,.alpo__btn:focus-visible{animation:none}',
    '@keyframes alHop{0%,82%,100%{transform:none;box-shadow:0 var(--al-e) 0 0 #111}' +
      '87%{transform:translateY(-4px);box-shadow:0 calc(var(--al-e) + 4px) 0 0 #111}' +
      '92%{transform:none;box-shadow:0 var(--al-e) 0 0 #111}' +
      '95%{transform:translateY(-1.5px);box-shadow:0 calc(var(--al-e) + 1.5px) 0 0 #111}}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  /* iPhone solo aplica :active (el hundido al tocar) si la pagina escucha los toques */
  document.addEventListener('touchstart', function () {}, { passive: true });

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.95 && r.bottom > 0;
  }
  function watch(els, onIn, margin) {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(onIn); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); onIn(e.target); } });
    }, { rootMargin: margin || '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  function later(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }

  /* ---------- 1. titulos ---------- */
  function titles() {
    var list = [];
    Array.prototype.forEach.call(document.querySelectorAll('.al h2'), function (h) {
      if (h.dataset.alw || h.children.length || h.closest('.alof,#cart-drawer')) return;
      var txt = h.textContent.replace(/\s+/g, ' ').trim();
      if (!txt) return;
      h.dataset.alw = '1';
      h.setAttribute('aria-label', txt);
      h.textContent = '';
      txt.split(' ').forEach(function (w, i) {
        if (i) h.appendChild(document.createTextNode(' '));
        var o = document.createElement('span'); o.className = 'alw'; o.setAttribute('aria-hidden', 'true');
        var n = document.createElement('span'); n.textContent = w; n.style.setProperty('--w', String(Math.min(i, 12)));
        o.appendChild(n); h.appendChild(o);
      });
      list.push(h);
    });
    var now = list.filter(inView), rest = list.filter(function (h) { return now.indexOf(h) < 0; });
    if (now.length) later(function () { now.forEach(function (h) { h.classList.add('alw-on'); }); });
    watch(rest, function (h) { h.classList.add('alw-on'); });
  }

  /* ---------- 2. fotos ---------- */
  var SKIP_IMG = '.alpo,.al-headwrap,.al-fl,.al-pd__gal,.al-pdSocial,.al-wheel,#cart-drawer,.alof,.al-gf,.al-stars';
  function photos() {
    var list = [];
    Array.prototype.forEach.call(document.querySelectorAll('.al img'), function (img) {
      if (img.dataset.alSettle || img.closest(SKIP_IMG)) return;
      img.dataset.alSettle = '1';
      var r = img.getBoundingClientRect();
      if (r.width < 120 || inView(img)) return;
      var p = img.parentElement, pr = p && p.getBoundingClientRect();
      if (!pr || Math.abs(pr.width - r.width) > 4 || Math.abs(pr.height - r.height) > 4) return;
      p.style.overflow = 'hidden';
      img.classList.add('al-settle');
      list.push(img);
    });
    watch(list, function (img) { img.classList.add('is-set'); }, '0px 0px -6% 0px');
  }

  /* ---------- 3. numeros que cuentan ---------- */
  var SKIP_NUM = '.alpo,.al-headwrap,.al-fl,.al-pdBuy,.al-pdPack,#cart-drawer,.al-cs,.alof,.al-promo,svg,script,style,button,a.al-buybar';
  var RE = /(\d{1,3})(?=\s?%)/g;   /* solo porcentajes */
  function fmt(v, dec) {
    if (dec) return v.toFixed(1).replace('.', ',');
    var s = String(Math.round(v));
    return s.length > 3 ? s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : s;
  }
  function counters() {
    var roots = document.querySelectorAll('main .al, .shopify-section .al');
    var spans = [];
    Array.prototype.forEach.call(roots, function (root) {
      var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), nodes = [], t;
      while ((t = tw.nextNode())) nodes.push(t);
      nodes.forEach(function (node) {
        var par = node.parentElement;
        if (!par || par.closest(SKIP_NUM) || par.classList.contains('al-count')) return;
        var s = node.nodeValue;
        RE.lastIndex = 0;
        if (!RE.test(s)) return;
        RE.lastIndex = 0;
        var frag = document.createDocumentFragment(), last = 0, m, any = false;
        while ((m = RE.exec(s))) {
          var prev = s.charAt(m.index - 1);
          if (/[\d\/.,\-+]/.test(prev)) continue;
          var raw = m[1], dec = raw.indexOf(',') > -1;
          var to = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
          if (!(to > 0)) continue;
          frag.appendChild(document.createTextNode(s.slice(last, m.index)));
          var sp = document.createElement('span');
          sp.className = 'al-count'; sp.textContent = raw;
          sp.dataset.to = String(to); sp.dataset.dec = dec ? '1' : '';
          frag.appendChild(sp); spans.push(sp);
          last = m.index + raw.length; any = true;
        }
        if (!any) return;
        frag.appendChild(document.createTextNode(s.slice(last)));
        par.replaceChild(frag, node);
      });
    });
    var todo = spans.filter(function (sp) { return !inView(sp); });
    todo.forEach(function (sp) { sp.textContent = fmt(0, sp.dataset.dec); });
    watch(todo, function (sp) {
      var to = parseFloat(sp.dataset.to), dec = !!sp.dataset.dec, t0 = 0, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        sp.textContent = fmt(to * e, dec);
        if (k < 1) requestAnimationFrame(step); else sp.textContent = fmt(to, dec);
      }
      requestAnimationFrame(step);
    });
  }

  function run() { try { titles(); } catch (e) {} try { photos(); } catch (e) {} try { counters(); } catch (e) {} }
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
})();
